import { render, staticRenderFns } from "./DataBoxes.vue?vue&type=template&id=49dbec2e&"
import script from "./DataBoxes.vue?vue&type=script&lang=js&"
export * from "./DataBoxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports